import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';

const GreenRadio = withStyles({
    root: {
      color: '#42642f',
      '&$checked': {
        color:'#42642f',
      },
      padding: '2px 10px',
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

export default GreenRadio;
